import * as React from 'react'
import { useEffect, useState } from 'react'
import Button from '@mui/material/Button'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { ListItemIcon } from '@mui/material'
import { ArrowDropDown, Download } from '@mui/icons-material'
import ListItemText from '@mui/material/ListItemText'
import PropTypes from 'prop-types'

/**
 * TODO: useMemo to cache response?
 */
const DownloadMenuItem = (type, value, key) => {
  const filename = value.split('/').pop()
  /**
   * Note: This works fine with S3 Hosted Assets
   * This does not work locally with JSON files due to
   * Content-Disposition headers not being set
   *
   * We should probably make a stream-file endpoint in the API to handle this
   * One day...
   */
  return (
    <MenuItem key={key} component="a" download={filename} href={value}>
      <ListItemIcon>
        <Download fontSize="small" />
      </ListItemIcon>
      <ListItemText>{type}</ListItemText>
    </MenuItem>
  )
}

export default function DownloadMenu(props) {
  const { record } = props
  const [anchorEl, setAnchorEl] = useState()
  const [menuItems, setMenuItems] = useState([])
  const open = Boolean(anchorEl)

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget)
  }

  useEffect(() => {
    const items = []
    Object.keys(record.modelDownloadURLs).map((keyName, i) => {
      items.push(
        DownloadMenuItem(keyName, record.modelDownloadURLs[keyName], i)
      )
    })
    if (menuItems.length === 0) {
      setMenuItems(items)
    }
  }, [menuItems])

  return (
    <>
      <Button
        aria-controls={open ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        endIcon={<ArrowDropDown sx={{ marginRight: '-10px' }} />}
      >
        Download File
      </Button>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
      >
        {menuItems.map((component) => component)}
      </Menu>
    </>
  )
}

DownloadMenuItem.propTypes = {
  type: PropTypes.string,
  url: PropTypes.string,
  key: PropTypes.number,
}

DownloadMenu.propTypes = {
  record: PropTypes.object,
}
